import { render, staticRenderFns } from "./PostFrame.vue?vue&type=template&id=d3a3563c&"
import script from "./PostFrame.vue?vue&type=script&lang=js&"
export * from "./PostFrame.vue?vue&type=script&lang=js&"
import style0 from "./PostFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports